import { EnumHelper, RecordUserLogEntryType } from "ui/Scripts/source/models/enums";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";

export interface IRecordEditItemLogListItem {
    id: string;
    entryType: RecordUserLogEntryType;
    entryTypeStr: string;
    callerIp: string;
    modifyUser: IModifyUser;
}

export class RecordEditItemLogListItem implements IRecordEditItemLogListItem {
    id: string;
    entryType: RecordUserLogEntryType;
    entryTypeStr: string;
    callerIp: string;
    modifyUser: ModifyUser;

    constructor();
    constructor(obj: IRecordEditItemLogListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.entryType = obj && obj.entryType || RecordUserLogEntryType.Create;
        this.entryTypeStr = EnumHelper.RecordUserLogEntryTypeToStr(this.entryType);
        this.callerIp = obj && obj.callerIp || "";
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }
}